import { Appointment } from 'src/models/appointment';

import { Callback } from 'src/util/query/models/Callback';

export class AppointmentCallback extends Callback<Appointment> {
	public constructor(private readonly setAppointment: (appointment: Appointment) => void) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: Appointment): void => {
		this.setAppointment(successResponse);
	};
}
